import React from 'react';
import { motion } from 'framer-motion';
import { Package, CheckCircle2 } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide9Wave1({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-342">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-343">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-344">
          Recommended First Wave
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-345">
          Wave 1:{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-346">
            Activate and prove.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-347">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-7 bg-[var(--surface)] rounded-2xl p-8 border border-black/5 flex flex-col" data-id="element-348">
          <div className="flex items-center gap-3 mb-6" data-id="element-349">
            <Package className="w-6 h-6 text-[var(--brand-green)]" data-id="element-350" />
            <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-351">
              A practical, commercially realistic pilot
            </h3>
          </div>

          <div className="space-y-6 flex-1 overflow-y-auto pr-4" data-id="element-352">
            <div className="bg-white p-5 rounded-xl border border-black/5" data-id="element-353">
              <div className="flex justify-between items-start mb-2" data-id="element-354">
                <h4 className="font-bold text-[var(--brand-green)] text-lg" data-id="element-355">
                  1. Website Snakkification
                </h4>
                <span className="font-bold text-[var(--fg)]" data-id="element-356">~€15,000</span>
              </div>
              <p className="text-[var(--muted)] text-sm font-medium" data-id="element-357">
                Core Anzupgo easy-to-digest Snak layer based on approved
                content. Creates reusable modular content library.
              </p>
            </div>

            <div className="bg-white p-5 rounded-xl border border-black/5" data-id="element-358">
              <div className="flex justify-between items-start mb-2" data-id="element-359">
                <h4 className="font-bold text-[var(--brand-green)] text-lg" data-id="element-360">
                  2. Four Teaser Masters*
                </h4>
                <span className="font-bold text-[var(--fg)]" data-id="element-361">
                  ~€10,000–€12,000
                </span>
              </div>
              <ul className="text-[var(--muted)] text-sm font-medium space-y-1" data-id="element-362">
                <li data-id="element-363">• When topical corticosteroids are not enough</li>
                <li data-id="element-364">• Not all CHE patients are the same</li>
                <li data-id="element-365">• Which CHE patient would you consider first?</li>
                <li data-id="element-366">• What is your main hesitation?</li>
              </ul>
              <p className="text-[var(--brand-green)] text-xs font-semibold mt-3 italic" data-id="element-367">
                * Each teaser is created as a ready-to-execute campaign and
                includes an animated hook for post, banner, email, etc.
              </p>
            </div>

            <div className="bg-white p-5 rounded-xl border border-black/5" data-id="element-368">
              <div className="flex justify-between items-start mb-2" data-id="element-369">
                <h4 className="font-bold text-[var(--brand-green)] text-lg" data-id="element-370">
                  3. Two Trailer Masters
                </h4>
                <span className="font-bold text-[var(--fg)]" data-id="element-371">~€9,000</span>
              </div>
              <ul className="text-[var(--muted)] text-sm font-medium space-y-1" data-id="element-372">
                <li data-id="element-373">• Why targeted topical treatment matters in CHE</li>
                <li data-id="element-374">• First appropriate use of Anzupgo</li>
              </ul>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-5 flex flex-col gap-6" data-id="element-375">
          <div className="bg-[var(--brand-green)] text-white rounded-2xl p-8 shadow-lg flex flex-col justify-center text-center" data-id="element-376">
            <p className="text-[var(--brand-green-lighter)] font-bold uppercase tracking-wider mb-2" data-id="element-377">
              Indicative Wave 1 Total
            </p>
            <h3 className="text-4xl font-bold" data-id="element-378">Approx. €34k–€36k</h3>
          </div>

          <div className="bg-[var(--surface)] p-6 rounded-2xl border border-black/5 flex-1 flex flex-col justify-center" data-id="element-379">
            <p className="text-[var(--muted)] text-sm font-medium leading-relaxed italic" data-id="element-380">
              * Pricing is indicative and subject to final scope, localization
              needs, asset availability, review rounds, and compliance
              requirements.
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}